/**
 * @generated SignedSource<<efe7e256fea930eede45035e2718d14d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpLayoutBackgroundType = "COLOR" | "IMAGE" | "TRANSPARENT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type sectionViewRendererFragment$data = {
  readonly __id: string;
  readonly subsections: ReadonlyArray<{
    readonly __id: string;
    readonly elements: ReadonlyArray<{
      readonly __typename: string;
      readonly __id: string;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"subsectionViewRendererFragment">;
  } | null> | null;
  readonly visualConfig: {
    readonly backgroundColor: string | null;
    readonly backgroundImage: {
      readonly url: string | null;
    } | null;
    readonly backgroundType: HelpLayoutBackgroundType | null;
    readonly hidden: boolean | null;
  } | null;
  readonly " $fragmentType": "sectionViewRendererFragment";
};
export type sectionViewRendererFragment$key = {
  readonly " $data"?: sectionViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionViewRendererFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "sectionViewRendererFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutSubsection",
      "kind": "LinkedField",
      "name": "subsections",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "subsectionViewRendererFragment"
        },
        {
          "kind": "LinkedField",
          "name": "elements",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            (v0/*: any*/)
          ]
        },
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "backgroundColor"
        },
        {
          "kind": "ScalarField",
          "name": "backgroundType"
        },
        {
          "concreteType": "HelpLayoutBackgroundImage",
          "kind": "LinkedField",
          "name": "backgroundImage",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "hidden"
        }
      ]
    },
    (v0/*: any*/)
  ],
  "type": "HelpLayoutSection"
};
})();

(node as any).hash = "6bcf831b6636972d2d3b732d17d7324f";

export default node;
